import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Modal.css';

const ModalHeader = ({
  className,
  children,
  ...otherProps
}) => {
  const classes = classNames(
    'header',
    'ng-ui-modal-header',
    className
  );

  return (
    <h2
      className={classes}
      {...otherProps}
    >
      {children}
    </h2>
  );
};

ModalHeader.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
    PropTypes.node,
  ]),
};

ModalHeader.displayName = 'Modal.Header';

export default ModalHeader;